import React from 'react';

const SvgCheck = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path fill="#4FCA33" fillRule="nonzero" d="M1 7.2L2.2 6l3 1.8L11.8 3 13 4.2 5.2 12z" />
    </svg>
);

export default SvgCheck;
